import { api } from './api';
import { renderLogin } from './loginView';
import { renderEmployeeDashboard } from './employeeDashboard';
import { renderAdminDashboard } from './adminDashboard';
import type { User } from './types';
import { showToast, t } from './dom';

const root = document.getElementById('app')!;

function showLogin() {
  renderLogin(root, (user, _accessToken) => {
    showDashboard(user);
  });
}

function showDashboard(user: User) {
  if (user.role === 'ADMIN') {
    renderAdminDashboard(root, user, handleLogout);
  } else {
    renderEmployeeDashboard(root, user, handleLogout);
  }
}

async function handleLogout() {
  try {
    await api.request('POST', '/auth/logout', undefined, { skipAuth: true });
  } catch {
    // Ignorar errores de logout
  }
  api.setAccessToken(null);
  showLogin();
}

// Si la sesión expira, volver al login
window.addEventListener('auth:expired', () => {
  showToast(t('common.sessionExpired'), 'error');
  showLogin();
});

// Intentar restaurar sesión con refresh token (cookie HttpOnly)
async function tryRestore() {
  try {
    const refreshResponse = await fetch(`${import.meta.env.VITE_API_URL ?? ''}/api/v1/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-Device-Id': api.getDeviceId() },
    });

    if (!refreshResponse.ok) {
      showLogin();
      return;
    }

    const refreshJson = await refreshResponse.json();
    if (!refreshJson.success) {
      showLogin();
      return;
    }

    api.setAccessToken(refreshJson.data.accessToken);

    const user = await api.request<User>('GET', '/me');
    showDashboard(user);
  } catch {
    showLogin();
  }
}

tryRestore();
